import { FundQueryMethod } from '../enums';


export const FundQueryMethods = [
  { name: 'Manual', value: FundQueryMethod.Manual },
  { name: 'Foundation Status Queries', value: FundQueryMethod.Foundation },
  { name: 'Fund Status Queries', value: FundQueryMethod.Fund },
];
